import request from '@/utils/request';
import { paymentServiceV1 } from '@/config/apiPrefix.config';

// 获取余额列表
export const getBalanceTabList = (data) => request(`${paymentServiceV1}/journal/get_journal_list`, {
  params: data,
});

// 获取余额信息
export const getBalance = (data) => request(`${paymentServiceV1}/balance/get_user_balance`, {
  params: data,
});

// 取消订单
export const cancelOrder = (data) => request(`${paymentServiceV1}/journal/cancel_journal`, {
  params: data,
  method: 'put',
});

// 用户充值申请
export const submitRecharge = (data) => request(`${paymentServiceV1}/journal/top_up_balance`, {
  body: data,
  method: 'put',
});

// 预付订单重新扣款
export const rePay = (data) => request(`${paymentServiceV1}/journal/pay_prepay_order`, {
  body: data,
  method: 'post',
});

// 用户确认转账
export const confirmRechargePay = (data) => request(`${paymentServiceV1}/journal/confirm_transfer`, {
  params: data,
  method: 'put',
});
